(() => {
  /**
   * Add ONLY the 90-day/3-bottle variant IDs here (one per product).
   * When one of these variants is selected, we auto-click the subscription selling plan.
   */
  const AUTO_VARIANT_IDS = new Set([
    40865453375552, // Product A 90-day variant
    40867648634944, // Product B 90-day variant
  ]);

  const MAX_TRIES = 12;
  const RETRY_MS = 150;

  function getAllVariantIdInputs() {
    // Some themes have multiple /cart/add forms (main + sticky + drawer).
    return Array.from(document.querySelectorAll('form[action^="/cart/add"] input[name="id"]'));
  }

  function getVariantIdFromInput(idInput) {
    const v = idInput?.value;
    if (!v) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  function findSellingPlanRadioForVariant(variantId) {
    // Your theme renders radios with data-radio-type="selling_plan"
    // and data-selling-plan-group-id ending with _<variantId>
    return document.querySelector(
      `input[type="radio"][data-radio-type="selling_plan"][data-selling-plan-group-id$="_${variantId}"]`
    );
  }

  function clickRadioOrLabel(radio) {
    if (!radio) return false;
    if (radio.checked) return true;

    const label = radio.closest('label');
    if (label) label.click();
    else radio.click();

    return true;
  }

  function tryAutoselectForVariant(variantId, tryNum = 1) {
    if (!AUTO_VARIANT_IDS.has(variantId)) return;

    const radio = findSellingPlanRadioForVariant(variantId);
    const clicked = clickRadioOrLabel(radio);

    // subscription widget often re-renders after variant change; retry briefly
    if ((!radio || (radio && !radio.checked) || !clicked) && tryNum < MAX_TRIES) {
      setTimeout(() => tryAutoselectForVariant(variantId, tryNum + 1), RETRY_MS);
    }
  }

  function attachWatcher(idInput) {
    const run = () => {
      const variantId = getVariantIdFromInput(idInput);
      if (!variantId) return;
      tryAutoselectForVariant(variantId);
    };

    // run immediately
    run();

    // observe Dawn/metafield-style variant swaps (value attribute changes)
    const obs = new MutationObserver(run);
    obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });

    // also listen for normal change (harmless)
    idInput.addEventListener("change", run);
  }

  function init() {
    const inputs = getAllVariantIdInputs();
    if (!inputs.length) return;

    inputs.forEach(attachWatcher);
  }

  document.addEventListener("DOMContentLoaded", init);
})();
